"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// All general words from the ESN project
var General = {
  we_are_sorry: {
    nl: "Het spijt ons!",
    fr: "Nous sommes désolés!",
    en: "We're sorry!",
    de: "Es tut uns leid!"
  },
  enterprise_cannot_be_found_anymre: {
    nl: "Deze onderneming is niet meer te vinden",
    fr: "Cette entreprise est introuvable",
    en: "This enterprise cannot be found anymore",
    de: "Dieses Unternehmen ist nicht mehr auffindbar"
  },
  redirecting_you_to_home: {
    nl: "U wordt omgeleid naar de home pagina..",
    fr: "Rediriger vers la page d'accueil..",
    en: "Redirecting you to home..",
    de: "Weiterleitung zur Startseite.."
  },
  go_back_to_home: {
    nl: "Terug naar home pagina",
    fr: "Retourner à l'accueil",
    en: "Go back to home",
    de: "Zurück zur Startseite"
  },
  back: {
    nl: "Terug",
    fr: "Retourner",
    en: "Back",
    de: "Zurück"
  },
  esn: {
    nl: 'osn',
    fr: 'rse',
    en: 'esn',
    de: 'esn'
  },
  load_more: {
    nl: 'Meer laden',
    fr: 'Charger plus',
    en: 'Load more',
    de: 'Mehr laden'
  },
  user: {
    nl: 'gebruiker',
    fr: 'utulisateur',
    en: 'user',
    de: 'Benutzer'
  },
  dutch: {
    nl: 'Nederlands',
    fr: 'Néerlandais',
    en: 'Dutch',
    de: 'Niederländisch'
  },
  french: {
    nl: 'Frans',
    fr: 'Français',
    en: 'French',
    de: 'Französisch'
  },
  english: {
    nl: 'Engels',
    fr: 'Anglais',
    en: 'English',
    de: 'Englisch'
  },
  lang_short: {
    nl: 'nl',
    fr: 'fr',
    en: 'en',
    de: 'de'
  },
  group: {
    nl: 'Groep',
    fr: 'Groupe',
    en: 'Group',
    de: 'Gruppe'
  },
  not_group: {
    nl: 'Niet groep',
    fr: 'Pas de groupe',
    en: 'not group',
    de: 'Keine Gruppe'
  },
  group_connections: {
    nl: 'Groepskoppelingen',
    fr: 'Connexions de groupe',
    en: 'Group connections',
    de: 'Gruppenverbindungen'
  },
  groups: {
    nl: 'Groepen',
    fr: 'Groupes',
    en: 'Groups',
    de: 'Gruppen'
  },
  all_groups: {
    nl: 'Alle groepen',
    fr: 'Toutes les groupes',
    en: 'All groups',
    de: 'Alle Gruppen'
  },
  cread: {
    nl: 'CREAD',
    fr: 'CREAD',
    en: 'CREAD',
    de: 'CREAD'
  },
  creads: {
    nl: 'CREADs',
    fr: 'CREADs',
    en: 'CREADs',
    de: 'CREADs'
  },
  all_creads: {
    nl: 'Alle CREADs',
    fr: 'Toutes les CREADs',
    en: 'All CREADs',
    de: 'Alle CREADs'
  },
  pages: {
    nl: "Pagina's",
    fr: 'Pages',
    en: 'Pages',
    de: 'Seiten'
  },
  icon: {
    nl: 'Icoon',
    fr: 'Icône',
    en: 'Icon',
    de: 'Symbol'
  },
  icons: {
    nl: 'Iconen',
    fr: 'Icônes',
    en: 'Icons',
    de: 'Symbole'
  },
  media: {
    nl: 'Media',
    fr: 'Médias',
    en: 'Media',
    de: 'Medien'
  },
  media_files: {
    nl: 'Media / bestand',
    fr: 'Média / fichier multimédia',
    en: 'Media / file',
    de: 'Medien / Datei'
  },
  search: {
    nl: 'Zoek naar',
    fr: 'Chercher',
    en: 'Search',
    de: 'Suche'
  },
  search_slug: {
    nl: 'zoeken',
    fr: 'chercher',
    en: 'search',
    de: 'suchen'
  },
  search_slug_2: {
    nl: 'zoeken-in',
    fr: 'rechercher-a',
    en: 'search-in',
    de: 'suchen-in'
  },
  search_in_slug: {
    nl: 'zoeken-in',
    fr: 'rechercher-a',
    en: 'search-in',
    de: 'suchen-in'
  },
  search_filters: {
    nl: 'Zoekfilters',
    fr: 'Filtres',
    en: 'Searchfilters',
    de: 'Suchfilter'
  },
  search_with_filters: {
    nl: 'Zoeken met filters',
    fr: 'Recherche avec filtres',
    en: 'Search with filters',
    de: 'Suche mit Filtern'
  },
  "in": {
    nl: 'in',
    fr: 'à',
    en: 'in',
    de: 'in'
  },
  search_dots: {
    nl: 'Zoek naar...',
    fr: 'Chercher...',
    en: 'Search...',
    de: 'Suche...'
  },
  search_and_add: {
    nl: 'Zoek en voeg toe...',
    fr: 'Rechercher et ajouter...',
    en: 'Search and add...',
    de: 'Suchen und hinzufügen...'
  },
  profile_settings: {
    nl: 'Profiel instellingen',
    fr: 'Paramètres profil',
    en: 'Profile settings',
    de: 'Profileinstellungen'
  },
  history: {
    nl: 'Geschiedenis',
    fr: 'Histoire',
    en: 'History',
    de: 'Verlauf'
  },
  notifications: {
    nl: 'Notificaties',
    fr: 'Les notifications',
    en: 'Notifications',
    de: 'Benachrichtigungen'
  },
  colleagues: {
    nl: "Collega's",
    fr: 'Collègues',
    en: 'Colleagues',
    de: 'Kollegen'
  },
  management: {
    nl: 'Beheer',
    fr: 'Administration',
    en: 'Management',
    de: 'Verwaltung'
  },
  export_data: {
    nl: 'Exporteer gegevens',
    fr: 'Exporter des données',
    en: 'Export data',
    de: 'Daten exportieren'
  },
  add: {
    nl: 'Voeg toe',
    fr: 'Ajouter',
    en: 'Add',
    de: 'Hinzufügen'
  },
  media_library: {
    nl: 'Media bibliotheek',
    fr: 'Médiathèque',
    en: 'Media library',
    de: 'Medienbibliothek'
  },
  all_icons: {
    nl: 'Alle iconen',
    fr: 'Toutes les icones',
    en: 'All icons',
    de: 'Alle Symbole'
  },
  all_media: {
    nl: 'Alle media',
    fr: 'Tous les médias',
    en: 'All media',
    de: 'Alle Medien'
  },
  active: {
    nl: 'Actief',
    fr: 'Actif',
    en: 'Active',
    de: 'Aktiv'
  },
  is_active: {
    nl: 'Actief',
    fr: 'Actif',
    en: 'Active',
    de: 'Aktiv'
  },
  start_date: {
    nl: 'Begindatum',
    fr: 'Date de début',
    en: 'Start date',
    de: 'Anfangsdatum'
  },
  end_date: {
    nl: 'Einddatum',
    fr: 'Date de fin',
    en: 'End date',
    de: 'Enddatum'
  },
  entity: {
    nl: 'Entiteit',
    fr: 'Entité',
    en: 'Entity',
    de: 'Entität'
  },
  update_date: {
    nl: 'Geüpdatet op',
    fr: 'Date mis à jour',
    en: 'Updated on',
    de: 'Aktualisiert am'
  },
  created_date: {
    nl: 'Aanmaakdatum',
    fr: 'Date de création',
    en: 'Created date',
    de: 'Erstellungsdatum'
  },
  entity_info: {
    nl: 'Informatie over entiteit',
    fr: "Information d'entité",
    en: 'Entity information',
    de: 'Entitätsinformationen'
  },
  edit: {
    nl: 'Bewerk',
    fr: 'Éditer',
    en: 'Edit',
    de: 'Bearbeiten'
  },
  settings: {
    nl: 'Instellingen',
    fr: 'Paramètres',
    en: 'Settings',
    de: 'Einstellungen'
  },
  draft: {
    nl: 'Klad',
    fr: 'Brouillon',
    en: 'Draft',
    de: 'Entwurf'
  },
  logo: {
    nl: 'Logo',
    fr: 'Logo',
    en: 'Logo',
    de: 'Logo'
  },
  name: {
    nl: 'Naam',
    fr: 'Nom',
    en: 'Name',
    de: 'Name'
  },
  description: {
    nl: 'Beschrijving',
    fr: 'Description',
    en: 'Description',
    de: 'Beschreibung'
  },
  no_description: {
    nl: 'Geen beschrijving',
    fr: 'Pas de description',
    en: 'No description',
    de: 'Keine Beschreibung'
  },
  describe_group: {
    nl: 'Beschrijf deze groep',
    fr: 'Décrire ce groupe',
    en: 'Describe this group',
    de: 'Beschreiben Sie diese Gruppe'
  },
  confirm: {
    nl: 'Bevestigen',
    fr: 'Confirmer',
    en: 'Confirm',
    de: 'Bestätigen'
  },
  delete_all: {
    nl: 'Verwijder alles',
    fr: 'Effacer tout',
    en: 'Remove all',
    de: 'Alles entfernen'
  },
  advanced_search: {
    nl: 'Geavanceerd zoeken',
    fr: 'Recherche avancée',
    en: 'Advanced search',
    de: 'Erweiterte Suche'
  },
  search_options: {
    nl: 'Zoekopties',
    fr: 'Options de recherche',
    en: 'Search options',
    de: 'Suchoptionen'
  },
  no_current_offers: {
    nl: 'Er zijn geen huidige aanbiedingen',
    fr: "Il n'y a pas d'offres a montrer",
    en: 'There are no current offers',
    de: 'Es gibt keine aktuellen Angebote'
  },
  current_offers: {
    nl: 'Huidige aanbiedingen',
    fr: 'Offres actuelles',
    en: 'Current offers',
    de: 'Aktuelle Angebote'
  },
  our_story: {
    nl: 'Ons verhaal',
    fr: 'Notre histoire',
    en: 'Our story',
    de: 'Unsere Geschichte'
  },
  in_the_picture: {
    nl: 'In de kijker',
    fr: "Mettre à l'honneur",
    en: 'In the picture',
    de: 'Im Rampenlicht'
  },
  business_page: {
    nl: 'Bedrijfspagina',
    fr: "Page d'entreprise",
    en: 'Business page',
    de: 'Firmenseite'
  },
  video_library: {
    nl: 'Video bibliotheek',
    fr: 'Vidéothèque',
    en: 'Video library',
    de: 'Videothek'
  },
  videos: {
    nl: "Video's",
    fr: 'Vidéos',
    en: 'Videos',
    de: 'Videos'
  },
  video: {
    nl: "Video",
    fr: 'Vidéo',
    en: 'Video',
    de: 'Video'
  },
  promos_and_catalogues: {
    nl: "Promo's & catalogi",
    fr: 'Promos et catalogues',
    en: 'Promos & catalogues',
    de: 'Aktionen & Kataloge'
  },
  promos_and_magazines: {
    nl: "Promo's & magazines",
    fr: 'Promos et magazines',
    en: 'Promos & magazines',
    de: 'Aktionen & Magazine'
  },
  promos_magazines: {
    nl: "Promo's & magazines",
    fr: 'Promos et magazines',
    en: 'Promos & magazines',
    de: 'Aktionen & Magazine'
  },
  info_and_magazines: {
    nl: "Info en magazines",
    fr: 'Infos et magazines',
    en: 'Info and magazines',
    de: 'Infos und Magazine'
  },
  brands: {
    nl: 'Merken',
    fr: 'Marques',
    en: 'Brands',
    de: 'Marken'
  },
  brand: {
    nl: 'Merk',
    fr: 'Marque',
    en: 'Brand',
    de: 'Marke'
  },
  manufacturers: {
    nl: 'Fabrikanten',
    fr: 'Fabricants',
    en: 'Manufacturers',
    de: 'Hersteller'
  },
  manufacturer: {
    nl: 'Fabrikant',
    fr: 'Fabricant',
    en: 'Manufacturer',
    de: 'Hersteller'
  },
  activites_and_services: {
    nl: 'Activiteiten & diensten',
    fr: 'Activités et services',
    en: 'Activities & services',
    de: 'Aktivitäten & Dienstleistungen'
  },
  activities: {
    nl: 'Activiteiten',
    fr: 'Activités',
    en: 'Activities',
    de: 'Aktivitäten'
  },
  news_articles: {
    nl: 'Nieuwsartikelen',
    fr: 'Articles de presse',
    en: 'News Articles',
    de: 'Nachrichtenartikel'
  },
  news_article: {
    nl: 'Nieuwsartikel',
    fr: 'Article de presse',
    en: 'News Article',
    de: 'Nachrichtenartikel'
  },
  eshop: {
    nl: 'E-shop',
    fr: 'E-shop',
    en: 'E-shop',
    de: 'E-Shop'
  },
  job_apply: {
    nl: 'Solliciteren',
    fr: 'Appliquer',
    en: 'Job apply',
    de: 'Bewerben'
  },
  floorplan: {
    nl: 'Grondplan',
    fr: "Plan d'étage",
    en: 'Floorplan',
    de: 'Grundriss'
  },
  footer: {
    nl: 'Footer',
    fr: "Footer",
    en: 'Footer',
    de: 'Fußzeile'
  },
  photo_album: {
    nl: 'Fotoalbum',
    fr: "Album photo",
    en: 'Photo album',
    de: 'Fotoalbum'
  },
  recipes: {
    nl: 'Recepten',
    fr: "Recettes",
    en: 'Recipes',
    de: 'Rezepte'
  },
  aperitif: {
    nl: 'Aperitief',
    fr: "Apéro",
    en: 'Aperitif',
    de: 'Aperitif'
  },
  side_dish: {
    nl: 'Bijgerecht',
    fr: "Accompagnements",
    en: 'Side dish',
    de: 'Beilage'
  },
  drink: {
    nl: 'Drank',
    fr: "Boisson",
    en: 'Drink',
    de: 'Getränk'
  },
  main_dish: {
    nl: 'Hoofdgerecht',
    fr: "Plat principal",
    en: 'Main dish',
    de: 'Hauptgericht'
  },
  snacks: {
    nl: 'Snacks',
    fr: "En-cas",
    en: 'Snacks',
    de: 'Snacks'
  },
  soup: {
    nl: 'Soep',
    fr: "Soupe",
    en: 'Soup',
    de: 'Suppe'
  },
  appetizer: {
    nl: 'Voorgerecht',
    fr: "Entrée",
    en: 'Appetizer',
    de: 'Vorspeise'
  },
  dessert: {
    nl: 'Nagerecht',
    fr: "Dessert",
    en: 'Dessert',
    de: 'Nachtisch'
  },
  back_to_results: {
    nl: 'Terug naar resultaten',
    fr: 'Retour aux résultats',
    en: 'Back to results',
    de: 'Zurück zu den Ergebnissen'
  },
  how_do_we_protect: {
    nl: 'Hoe beschermen wij jouw privacy?',
    fr: 'Comment protégeons-nous vos données?',
    en: 'How do we protect your privacy?',
    de: 'Wie schützen wir Ihre Privatsphäre?'
  },
  support: {
    nl: 'Support',
    fr: 'Assistance',
    en: 'Support',
    de: 'Support'
  },
  privacy_policy: {
    nl: 'Privacybeleid',
    fr: 'Charte de confidentialité',
    en: 'Privacy policy',
    de: 'Datenschutzrichtlinie'
  },
  terms_and_conditions: {
    nl: 'Algemene voorwaarden',
    fr: 'Conditions générales',
    en: 'Terms & Conditions',
    de: 'Allgemeine Geschäftsbedingungen'
  },
  of: {
    nl: 'van',
    fr: 'de',
    en: 'of',
    de: 'von'
  },
  "with": {
    nl: 'met',
    fr: 'avec',
    en: 'with',
    de: 'mit'
  },
  result: {
    nl: 'resultaat',
    fr: 'résultat',
    en: 'result',
    de: 'Ergebnis'
  },
  results: {
    nl: 'resultaten',
    fr: 'résultats',
    en: 'results',
    de: 'Ergebnisse'
  },
  discover_more: {
    nl: 'Ontdek meer',
    fr: 'Découvrez plus',
    en: 'Discover more',
    de: 'Entdecke mehr'
  },
  visit_site: {
    nl: 'Bezoek website',
    fr: 'Visitez notre site',
    en: 'Visit site',
    de: 'Website besuchen'
  },
  your_search_results: {
    nl: 'Jouw zoekresultaten | Ondernemers & Shoppingnetwerk',
    fr: 'Vos résultats de recherche | Réseau Shopping & Entrepreneurs',
    en: 'Your search results | Entrepreneurs & Shoppingnetwork',
    de: 'Ihre Suchergebnisse | Unternehmer- & Einkaufsnetzwerk'
  },
  unknown_error: {
    nl: 'Er ging iets mis! Het ligt niet aan jou maar aan ons',
    fr: "Quelque chose s'est mal passé! Ce n'est pas à vous mais à nous",
    en: "Something went wrong! It's not you; it's us",
    de: "Etwas ist schief gelaufen! Es liegt nicht an Ihnen, sondern an uns"
  },
  cant_find_results: {
    nl: 'Sorry! Er konden geen resultaten worden gevonden',
    fr: "Désoler! Aucun résultat n'a pu être trouvé",
    en: 'Sorry! No results could be found',
    de: 'Entschuldigung! Es konnten keine Ergebnisse gefunden werden'
  },
  page: {
    nl: 'Pagina',
    fr: 'Page',
    en: 'Page',
    de: 'Seite'
  },
  firstname: {
    nl: 'Voornaam',
    fr: 'Prénom',
    en: 'First name',
    de: 'Vorname'
  },
  lastname: {
    nl: 'Achternaam',
    fr: 'Nom',
    en: 'Last name',
    de: 'Nachname'
  },
  how_to_bookmark: {
    nl: 'Druk op CTRL + D om toe te voegen aan bladwijzers',
    fr: 'Appuyez sur CTRL + D pour ajouter aux favoris',
    en: 'Press CTRL + D to add to bookmarks',
    de: 'Drücken Sie STRG + D, um ein Lesezeichen hinzuzufügen'
  },
  entrepreneur: {
    nl: 'Ondernemer',
    fr: 'Entrepreneur',
    en: 'Entrepreneur',
    de: 'Unternehmer'
  },
  title: {
    nl: 'Title',
    fr: 'Titre',
    en: 'Title',
    de: 'Titel'
  },
  duration: {
    nl: 'Looptijd',
    fr: 'La durée',
    en: 'Duration',
    de: 'Dauer'
  },
  am_sure: {
    nl: 'Ik ben zeker!',
    fr: 'Je suis sure!',
    en: 'I\'m sure!',
    de: 'Ich bin sicher!'
  },
  changed_my_mind: {
    nl: 'Ben van gedacht veranderd',
    fr: 'J\'ai changé d\'avis',
    en: 'I\'ve changed my mind',
    de: 'Ich habe meine Meinung geändert'
  },
  sure_you_want_to_delete: {
    nl: 'Ben je zeker dat je dit wilt verwijderen?',
    fr: 'Voulez-vous vraiment supprimer cela?',
    en: 'Are you sure you want to delete this?',
    de: 'Sind Sie sicher, dass Sie dies löschen möchten?'
  },
  from: {
    nl: 'Van',
    fr: 'De',
    en: 'From',
    de: 'Von'
  },
  to: {
    nl: 'Tot',
    fr: 'à',
    en: 'To',
    de: 'Bis'
  },
  no_linked: {
    nl: 'Geen gekoppelde',
    fr: 'Pas de lien',
    en: 'No linked',
    de: 'Keine Verknüpfung'
  },
  selected: {
    nl: 'Geselecteerde',
    fr: 'Sélectionné',
    en: 'Selected',
    de: 'Ausgewählt'
  },
  esn_name: {
    nl: 'Ondernemers & Shoppingnetwerk',
    fr: 'Réseau Shopping & Entrepreneurs',
    en: 'Entrepreneurs & Shoppingnetwork',
    de: 'Unternehmer- & Einkaufsnetzwerk'
  },
  esn_description: {
    nl: 'Als meest privacyvriendelijke en relevante zoekmachine biedt het ondernemersnetwerk jou alle Belgische ondernemers in één netwerk aan.',
    fr: "En tant que moteur de recherche le plus adapter à votre recherche et le plus respectueux de la vie privée, le Réseau Entrepreneurs vous propose tous les entrepreneurs Belges d'un même réseau.",
    en: 'As the most privacy-friendly and relevant search engine, the Entrepreneur network offers you all Belgian entrepreneurs in one network.',
    de: 'Als die datenschutzfreundlichste und relevanteste Suchmaschine bietet Ihnen das Unternehmernetzwerk alle belgischen Unternehmer in einem Netzwerk.'
  },
  search_engine: {
    nl: 'Zoekmachine',
    fr: 'Moteur de recherche',
    en: 'Search engine',
    de: 'Suchmaschine'
  },
  esn_alt: {
    nl: 'Logo Ondernemersnetwerk',
    fr: 'Logo Réseau d’Etrepreneurs',
    en: 'Logo Entrepreneursnetwork',
    de: 'Logo Unternehmernetzwerk'
  },
  cn_alt: {
    nl: 'Logo Catalogusnetwerk',
    fr: 'Logo Réseau Catalogue',
    en: 'Logo Catalogue network',
    de: 'Logo Katalognetzwerk'
  },
  pn_alt: {
    nl: 'Logo Promonetwerk',
    fr: 'Logo Réseau Promo',
    en: 'Logo Promo network',
    de: 'Logo Promonetzwerk'
  },
  networks: {
    nl: 'Alle netwerken',
    fr: 'Tout nos réseaux',
    en: 'All networks',
    de: 'Alle Netzwerke'
  },
  lang_menu_0: {
    nl: 'Nederlands',
    fr: 'Français',
    en: 'English',
    de: 'Deutsch'
  },
  search_engine_desc: {
    nl: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "Meest ", /*#__PURE__*/_react["default"].createElement("strong", null, "privacyvriendelijke"), " en relevante zoekresultaten van ", /*#__PURE__*/_react["default"].createElement("strong", null, "alle Belgische ondernemers")),
    fr: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "Le moteur de recherche ", /*#__PURE__*/_react["default"].createElement("strong", null, "le plus confidentiel"), " avec des r\xE9sultats adapter \xE0 votre recherche ", /*#__PURE__*/_react["default"].createElement("strong", null, "des entrepreneurs Belge")),
    en: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "Most ", /*#__PURE__*/_react["default"].createElement("strong", null, "privacy-friendly"), " and relevant search results ", /*#__PURE__*/_react["default"].createElement("strong", null, "of all Belgian entrepreneurs")),
    de: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "Die ", /*#__PURE__*/_react["default"].createElement("strong", null, "datenschutzfreundlichsten"), " und relevantesten Suchergebnisse ", /*#__PURE__*/_react["default"].createElement("strong", null, "aller belgischen Unternehmer"))
  },
  search_engine_desc_local: {
    nl: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "Meest ", /*#__PURE__*/_react["default"].createElement("strong", null, "privacyvriendelijke"), " en relevante zoekresultaten van ", /*#__PURE__*/_react["default"].createElement("strong", null, "alle lokale ondernemers in")),
    fr: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "Le moteur de recherche ", /*#__PURE__*/_react["default"].createElement("strong", null, "le plus confidentiel"), " avec des r\xE9sultats pertinants ", /*#__PURE__*/_react["default"].createElement("strong", null, "des entrepreneurs locaux \xE0")),
    en: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "Most ", /*#__PURE__*/_react["default"].createElement("strong", null, "privacy-friendly"), " and relevant search results ", /*#__PURE__*/_react["default"].createElement("strong", null, "of all local entrepreneurs in")),
    de: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "Die ", /*#__PURE__*/_react["default"].createElement("strong", null, "datenschutzfreundlichsten"), " und relevantesten Suchergebnisse ", /*#__PURE__*/_react["default"].createElement("strong", null, "aller lokalen Unternehmer in"))
  },
  local_enterprises: {
    nl: 'Lokale ondernemingen in',
    fr: 'Entreprises locales à',
    en: 'Local enterprises in',
    de: 'Lokale Unternehmen in'
  },
  my_company: {
    nl: 'Mijn bedrijf',
    fr: 'Mon enterprise',
    en: 'My company',
    de: 'Mein Unternehmen'
  },
  cookies_message: {
    nl: /*#__PURE__*/_react["default"].createElement("div", null, "Wij gebruiken cookies om uw laatste zoekresultaten te tonen. ", /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("br", null), " Wanneer u accepteert is dit de enige cookie die wij voor uw gebruiksgemak opslaan in uw browser."),
    fr: /*#__PURE__*/_react["default"].createElement("div", null, "Nous utilisons des cookies pour afficher vos derniers r\xE9sultats de recherche. ", /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("br", null), " Si vous l'acceptez, c'est le seul cookie que nous stockons dans votre navigateur pour votre facilit\xE9 d'utilisation.."),
    en: /*#__PURE__*/_react["default"].createElement("div", null, "We use cookies to display your latest search results. ", /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("br", null), " If you accept, this is the only cookie we store in your browser for your ease of use."),
    de: /*#__PURE__*/_react["default"].createElement("div", null, "Wir verwenden Cookies, um Ihre letzten Suchergebnisse anzuzeigen. ", /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("br", null), " Wenn Sie akzeptieren, ist dies das einzige Cookie, das wir zu Ihrem Komfort in Ihrem Browser speichern.")
  },
  cookies_1: {
    nl: "We gebruiken cookies om u uw laatste zoekresultaten te tonen.",
    fr: "Nous utilisons des cookies pour vous montrer vos derniers résultats de recherche.",
    en: "We use cookies to show you your latest search results.",
    de: "Wir verwenden Cookies, um Ihnen Ihre letzten Suchergebnisse anzuzeigen."
  },
  cookies_2: {
    nl: "Uw voorkeur (geaccepteerd of geweigerd) is de enige noodzakelijke cookie die in uw browser wordt opgeslagen.",
    fr: "Votre préférence (acceptée ou refusée) est le seul cookie nécessaire enregistré dans votre navigateur.",
    en: "Your preference (accepted or refused) is the only necessary cookie saved in your browser.",
    de: "Ihre Präferenz (akzeptiert oder abgelehnt) ist das einzige notwendige Cookie, das in Ihrem Browser gespeichert wird."
  },
  accept: {
    nl: "Accepteer",
    fr: "Accepter",
    en: "Accept",
    de: "Akzeptieren"
  },
  refuse: {
    nl: "Weigeren",
    fr: "Refuser",
    en: "Refuse",
    de: "Ablehnen"
  },
  yes_message: {
    nl: "Ja",
    fr: "Oui",
    en: "Yes",
    de: "Ja"
  },
  no_message: {
    nl: "Nee",
    fr: "Non",
    en: "No",
    de: "Nein"
  },
  of_the: {
    nl: "Van de",
    fr: "Du",
    en: "Of",
    de: "Von"
  },
  reCaptcha: {
    nl: "Kan niet valideren",
    fr: "Impossible de valider",
    en: "Failed to validate",
    de: "Überprüfung fehlgeschlagen"
  },
  opening_hours_check: {
    nl: "Even geduld, We kijken de openingsuren van dit bedrijf na !",
    fr: "Veuillez patienter, nous vérifions les heures d'ouverture sur cette entreprise !",
    en: "Hold on, while we are checking the opening hours of this enterprise !",
    de: "Warten Sie einen Moment, während wir die Öffnungszeiten dieses Unternehmens überprüfen!"
  },
  percent_local: {
    nl: "100procentlokaal",
    fr: "100pourcentlocale",
    en: "100percentlocal",
    de: "100prozentlokal"
  },
  contact_url: {
    nl: "contact",
    fr: "contact",
    en: "contact",
    de: "kontakt"
  },
  current_offers_url: {
    nl: "huidige-aanbiedingen",
    fr: "offres-actuelles",
    en: "current-offers",
    de: "aktuelle-angebote"
  },
  our_story_url: {
    nl: 'ons-verhaal',
    fr: 'notre-histoire',
    en: 'our-story',
    de: 'unsere-geschichte'
  },
  videos_url: {
    nl: "videos",
    fr: "videos",
    en: "videos",
    de: "videos"
  },
  digital_display_url: {
    nl: "promos-magazines",
    fr: "promos-magazines",
    en: "promos-magazines",
    de: "promos-magazine"
  },
  brands_url: {
    nl: "merken",
    fr: "marques",
    en: "brands",
    de: "marken"
  },
  activities_url: {
    nl: "activiteiten",
    fr: "activités",
    en: "activities",
    de: "aktivitäten"
  },
  message_from: {
    nl: "Bericht van",
    fr: "message de",
    en: "Message from",
    de: "Nachricht von"
  },
  valid_until: {
    nl: "Geldig tot",
    fr: "Valable jusqu'au",
    en: "Valid until",
    de: "Gültig bis"
  },
  read_more: {
    nl: "Lees meer",
    fr: "Plus d'info",
    en: "Read more",
    de: "Mehr lesen"
  },
  go_to: {
    nl: 'Ga naar',
    fr: 'Allez sur',
    en: 'Go to',
    de: 'Gehe zu'
  },
  this_city_is_not_sharing_its_books_here_yet: {
    nl: 'Deze stad deelt haar boekjes hier nog niet',
    fr: 'Cette ville ne partage pas encore ses livres ici',
    en: 'This city is not sharing its books here yet',
    de: 'Diese Stadt teilt ihre Bücher hier noch nicht'
  },
  this_municipality_is_not_sharing_its_books_here_yet: {
    nl: 'Deze gemeente deelt haar boekjes hier nog niet',
    fr: 'Cette commune ne partage pas encore ses livres ici',
    en: 'This municipality is not sharing its books here yet',
    de: 'Diese Gemeinde teilt ihre Bücher hier noch nicht'
  },
  search_for_all_enterprises: {
    nl: 'Zoek naar alle handelaars en ondernemers van',
    fr: 'Recherchez tous les commerçants et entrepreneurs de',
    en: 'Search for all traders and entrepreneurs of',
    de: 'Suche nach allen Händlern und Unternehmern von'
  },
  search_for_all_enterprises_main: {
    nl: 'Zoek naar alle handelaars en ondernemers ...',
    fr: 'Recherchez tous les commerçants et entrepreneurs ...',
    en: 'Search for all traders and entrepreneurs ...',
    de: 'Suche nach allen Händlern und Unternehmern ...'
  },
  follow: {
    nl: 'Volgen',
    fr: 'Suivre',
    en: 'Follow',
    de: 'Folgen'
  },
  cookie_mc_1: {
    nl: 'Wij gebruiken alleen cookies om bij te houden of dit bericht al is weergegeven',
    fr: 'Nous utilisons uniquement des cookies pour savoir si ce message a déjà été affiché',
    en: 'We only use cookies to keep track of whether this message has already been displayed',
    de: 'Wir verwenden nur Cookies, um zu verfolgen, ob diese Nachricht bereits angezeigt wurde'
  },
  cookie_mc_2: {
    nl: 'Wanneer u accepteert is dit de enige cookie die wij opslaan in uw browser.',
    fr: "Lorsque vous acceptez, c'est le seul cookie que nous stockons dans votre navigateur.",
    en: 'When you accept, this is the only cookie we store in your browser.',
    de: 'Wenn Sie akzeptieren, ist dies das einzige Cookie, das wir in Ihrem Browser speichern.'
  },
  your_city_or_municipality_has_a_lot_to_tell_you: {
    nl: 'Uw stad of gemeente heeft u veel te vertellen en zij deelt dit graag met haar bewoners. Regelmatig verschijnt er dan ook een info- magazine met heel wat nuttige informatie.',
    fr: 'Votre ville ou commune a beaucoup à vous dire et elle est heureuse de partager cela avec ses habitants. Un magazine d’information est donc régulièrement publié avec beaucoup d’informations utiles.',
    en: 'Your city or municipality has a lot to tell you and it is happy to share this with its residents. An information magazine is therefore regularly published with a lot of useful information.',
    de: 'Ihre Stadt oder Gemeinde hat Ihnen viel zu sagen und teilt dies gerne mit ihren Bewohnern. Ein Informationsmagazin wird daher regelmäßig mit vielen nützlichen Informationen veröffentlicht.'
  },
  do_you_also_want_to_stay_informed: {
    nl: 'Wil jij ook op de hoogte blijven wanneer jouw stad of gemeente nieuwe info publiceert? Maak een persoonlijk account aan om een melding te ontvangen!',
    fr: 'Voulez-vous également rester informé lorsque votre ville ou commune publie de nouvelles informations? Créez un compte personnel pour recevoir une notification!',
    en: 'Do you also want to stay informed when your city or municipality publishes new information? Create a personal account to receive a notification!',
    de: 'Möchten Sie auch informiert bleiben, wenn Ihre Stadt oder Gemeinde neue Informationen veröffentlicht? Erstellen Sie ein persönliches Konto, um eine Benachrichtigung zu erhalten!'
  },
  also_from_an_ecological_point_of_view: {
    nl: 'Ook vanuit een ecologisch stand- punt willen zij u in de toekomst de verspreiding van deze informatie niet alleen aanbieden d.m.v. drukwerk maar ook online op:',
    fr: 'Du point de vue écologique également, ils veulent vous offrir la diffusion de ces informations à l’avenir, non seulement au moyen d’imprimés, mais aussi en ligne à:',
    en: 'Also from an ecological point of view they want to offer you the dissemination of this information in the future not only by means of printed matter but also online at:',
    de: 'Auch aus ökologischer Sicht möchten sie Ihnen die Verbreitung dieser Informationen in Zukunft nicht nur in Form von Drucksachen, sondern auch online anbieten:'
  },
  printing_is_no_longer_the_norm: {
    nl: 'Tegenwoordig is drukwerk ook niet meer de norm. Het is duur, tijdrovend en moeilijker te verspreiden. Eventuele fouten zijn ook niet meer te herstellen. Bij online verspreiding zijn talloze kanalen mogelijk en is alles snel aanpasbaar. Uw stad of gemeente is ervan overtuigd dat zij met de besparing op drukwerk extra acties kunnen ondernemen die de bevolking dient.',
    fr: 'L’impression n’est plus la norme de nos jours. Elle est coûteuse, longue et plus difficile à distribuer. Toute erreur ne peut plus être corrigée. Avec la distribution en ligne, De nombreux canaux sont possibles et tout est rapidement adaptable. Votre ville ou municipalité est convaincue qu’avec les économies sur l’impression, ils peuvent prendre des mesures supplémentaires qui servent la population.',
    en: 'Printing is no longer the norm these days. It is expensive, time consuming and more difficult to distribute. Any errors can no longer be corrected. With online distribution, countless channels are possible and everything is quickly adaptable. Your city or municipality is convinced that with the savings on printing, they can take extra actions that serve the population.',
    de: 'Drucksachen sind heutzutage nicht mehr die Norm. Sie sind teuer, zeitaufwändig und schwieriger zu verteilen. Fehler können nicht mehr korrigiert werden. Bei der Online-Verbreitung sind zahllose Kanäle möglich, und alles ist schnell anpassbar. Ihre Stadt oder Gemeinde ist überzeugt, dass sie mit den Einsparungen bei den Druckkosten zusätzliche Maßnahmen ergreifen können, die der Bevölkerung dienen.'
  },
  search_for_a_promo: {
    nl: 'Zoek naar een promo',
    fr: 'Cherchez une dépliant promo',
    en: 'Search for a promo',
    de: 'Suche nach einer Promo'
  },
  search_for_a_magazine: {
    nl: 'Zoek naar een magazine, catalogus of infoblad',
    fr: "Cherchez une magazine, un catalogue ou une fiche d'information",
    en: 'Search for a magazine, catalogue or info sheet',
    de: 'Suche nach einem Magazin, Katalog oder Informationsblatt'
  },
  publications: {
    nl: 'Publicaties',
    fr: "Publications",
    en: 'Publications',
    de: 'Veröffentlichungen'
  },
  preferred_language: {
    nl: 'Taalvoorkeur',
    fr: 'Préférence de langue',
    en: 'Preferred language',
    de: 'Bevorzugte Sprache'
  },
  email_or_username: {
    nl: 'E-mailadres of gebruikersnaam',
    fr: "E-mail ou nom d'utilisateur",
    en: 'E-mail or username',
    de: 'E-Mail oder Benutzername'
  },
  disabled_by: {
    nl: 'Uitgeschakeld door',
    fr: "Désactivé par",
    en: 'Disabled by',
    de: 'Deaktiviert durch'
  },
  disabled_by_2: {
    nl: 'ondernemer',
    fr: "l'entrepreneur",
    en: 'enterprise',
    de: 'Unternehmer'
  },
  i_am_consumer: {
    nl: 'Ik ben consument',
    fr: "je suis consommateur",
    en: 'I am consumer',
    de: 'Ich bin Verbraucher'
  },
  i_am_entrepreneur: {
    nl: 'Ik ben ondernemer',
    fr: "je suis entrepreneur",
    en: 'I am entrepreneur',
    de: 'Ich bin Unternehmer'
  },
  register: {
    nl: 'Registreer',
    fr: "S'inscrire",
    en: 'Register',
    de: 'Registrieren'
  },
  log_out: {
    nl: 'Afmelden',
    fr: "Déconnecter",
    en: 'Log out',
    de: 'Abmelden'
  },
  saved_cmps: {
    nl: "Opgeslagen promofolders",
    fr: "Dépliant promos",
    en: "Saved promos",
    de: "Gespeicherte Werbeaktionen"
  },
  following_establishments: {
    nl: "Gevolgde ondernemers",
    fr: "Entrepreneurs suivis",
    en: "Followed entrepreneurs",
    de: "Verfolgte Unternehmer"
  },
  previous_work_experience: {
    nl: 'Vorige werkervaring',
    fr: "Précédente expérience professionnelle",
    en: 'Previous work experience',
    de: 'Bisherige Berufserfahrung'
  },
  motivation: {
    nl: 'Motivatie',
    fr: "Motivation",
    en: 'Motivation',
    de: 'Motivation'
  },
  send: {
    nl: 'Verzenden',
    fr: "Envoyer",
    en: 'Send',
    de: 'Senden'
  },
  vacancies: {
    nl: 'Vacatures',
    fr: "Postes vacants",
    en: 'Vacancies',
    de: 'Stellenangebote'
  },
  our_details: {
    nl: 'Onze gegevens',
    fr: 'Nos coordonnées',
    en: 'Our details',
    de: 'Unsere Daten'
  },
  lets_connect: {
    nl: "Let's connect!",
    fr: "Connectons-nous !",
    en: "Let's connect!",
    de: "Lass uns verbinden!"
  },
  created_for: {
    nl: "gemaakt voor",
    fr: "créé pour",
    en: "created for",
    de: "erstellt für"
  },
  the_entrepreneurs_network: {
    nl: "Het Ondernemersnetwerk",
    fr: "La Reseau Entrepreneurs",
    en: "The Entrepreneurs Network!",
    de: "Das Unternehmernetzwerk!"
  },
  concept_and_realisation_by: {
    nl: "Concept & Realisatie door",
    fr: "Concept & Réalisation par",
    en: "Concept & Realisation by",
    de: "Konzept & Realisierung durch"
  },
  visit_our_eshop: {
    nl: "Bezoek onze e-shop",
    fr: "Visiter notre e-shop",
    en: "Visit our e-shop",
    de: "Besuchen Sie unseren E-Shop"
  },
  visit_our_eshop_now: {
    nl: "Bezoek nu onze webshop",
    fr: "Visiter notre e-shop",
    en: "Visit our e-shop now",
    de: "Besuchen Sie jetzt unseren E-Shop"
  },
  our_eshop: {
    nl: "Onze e-shop",
    fr: "Notre e-shop",
    en: "Our e-shop",
    de: "Unser E-Shop"
  },
  our_floorplan: {
    nl: "Ons grondplan",
    fr: "Notre plan d'étage",
    en: "Our floorplan",
    de: "Unser Grundriss"
  },
  are_you_ready_for_a_new_adventure: {
    nl: "Ben je klaar voor een nieuw avontuur ?",
    fr: "Êtes-vous prêt pour une nouvelle aventure ?",
    en: "Are you ready for a new adventure ?",
    de: "Bist du bereit für ein neues Abenteuer?"
  },
  job_type: {
    nl: "Job type",
    fr: "Type d'emploi",
    en: "Job type",
    de: "Berufstyp"
  },
  half_time: {
    nl: "Halftijds",
    fr: "Mi-temps",
    en: "Half-time",
    de: "Teilzeit"
  },
  full_time: {
    nl: "Voltijds",
    fr: "Temps plein",
    en: "Full-time",
    de: "Vollzeit"
  },
  vacation_job: {
    nl: "Vakantiejob",
    fr: "Emploi de vacances",
    en: "Vacation job",
    de: "Ferienjob"
  },
  weekendjob: {
    nl: "Weekendjob",
    fr: "Emploi du week-end",
    en: "Weekendjob",
    de: "Wochenendjob"
  },
  flexi_job: {
    nl: "Flexi-job",
    fr: "Job flexi",
    en: "Flexi-job",
    de: "Flexi-Job"
  },
  you_have_experience_in_sales: {
    nl: "Heeft u enige verkoopervaring?",
    fr: "Avez-vous une expérience de vente ?",
    en: "Do you have any professional experience in sales?",
    de: "Haben Sie Berufserfahrung im Verkauf?"
  },
  cash_desk: {
    nl: "Kassa",
    fr: "Caisse",
    en: "Cash desk",
    de: "Kasse"
  },
  butchery: {
    nl: "Slagerij",
    fr: "Boucherie",
    en: "Butchery",
    de: "Metzgerei"
  },
  bakery: {
    nl: "Bakkerij",
    fr: "Boulangerie",
    en: "Bakery",
    de: "Bäckerei"
  },
  Wines_spirits: {
    nl: "Wijnen & sterke drank",
    fr: "Vins et spiritueux",
    en: "Wines & spirits",
    de: "Weine & Spirituosen"
  },
  fruits_and_vegetables: {
    nl: "Groenten en fruit",
    fr: "Fruits et légumes",
    en: "Fruits and vegetables",
    de: "Obst und Gemüse"
  },
  upload_your_cv: {
    nl: "Upload jouw CV",
    fr: "Téléchargez votre CV ici !",
    en: "Upload your CV",
    de: "Lade deinen Lebenslauf hoch"
  },
  only_in_pdf: {
    nl: "Enkel in .pdf",
    fr: "Uniquement en .pdf",
    en: "Only in .pdf",
    de: "Nur im .pdf-Format"
  },
  save_points_with_a_smile: {
    nl: "Punten sparen met een Smile",
    fr: "Economisez des points avec un Smile",
    en: "Save points with a smile",
    de: "Punkte mit einem Lächeln sammeln"
  },
  view_our_allergen_list: {
    nl: "Bekijk onze menu en allergenenlijst online!",
    fr: "Consultez notre menu et notre liste d'allergènes en ligne !",
    en: "View our menu and allergen list online!",
    de: "Sehen Sie sich unser Menü und unsere Allergieliste online an!"
  },
  save_food: {
    nl: "RED VOEDSEL",
    fr: "SAUVE DE LA NOURRITURE",
    en: "SAVE FOOD",
    de: "RETTET LEBENSMITTEL"
  },
  help_the_planet: {
    nl: "HELP DE PLANEET",
    fr: "AIDE LA PLANÈTE",
    en: "HELP THE PLANET",
    de: "HILF DEM PLANETEN"
  },
  our_team: {
    nl: "Ons team",
    fr: "Notre équipe",
    en: "Our team",
    de: "Unser Team"
  },
  delicious_and_local: {
    nl: "Lekker lokaal",
    fr: "Délicieux et locaux",
    en: "Delicious and local",
    de: "Lecker und lokal"
  },
  our_valuable_assets: {
    nl: "Onze troeven",
    fr: "Nos atouts",
    en: "Our valuable assets",
    de: "Unsere wertvollen Stärken"
  },
  wholesale: {
    nl: "Groothandel",
    fr: "De gros",
    en: "Wholesale",
    de: "Großhandel"
  },
  local_products: {
    nl: "Lokale producten",
    fr: "Produits locaux",
    en: "Local products",
    de: "Lokale Produkte"
  },
  news: {
    nl: "Nieuws",
    fr: "Nouvelles",
    en: "News",
    de: "Nachrichten"
  },
  shopping_list: {
    nl: "Boodschappenlijst",
    fr: "Liste de courses",
    en: "Shopping list",
    de: "Einkaufsliste"
  },
  add_a_product: {
    nl: "Voeg een product toe . . .",
    fr: "Ajouter un produit . . .",
    en: "Add a product . . .",
    de: "Ein Produkt hinzufügen . . ."
  },
  new_list: {
    nl: "Nieuwe lijst",
    fr: "Nouvelle liste",
    en: "New list",
    de: "Neue Liste"
  },
  exclusive_for_followers: {
    nl: "Exclusief voor volgers",
    fr: "Exclusif aux abonnés",
    en: "Exclusive for followers",
    de: "Exklusiv für Follower"
  },
  followers: {
    nl: "volgers",
    fr: "abonnés",
    en: "followers",
    de: "Follower"
  },
  this_week: {
    nl: "Deze week",
    fr: "Semaine actuelle",
    en: "This week",
    de: "Diese Woche"
  },
  next_week: {
    nl: "Volgende week",
    fr: "Semaine prochaine",
    en: "Next week",
    de: "Nächste Woche"
  },
  this_period: {
    nl: "Huidige periode",
    fr: "Periode actuelle",
    en: "This Period",
    de: "Diese Periode"
  },
  next_period: {
    nl: "Volgende periode",
    fr: "periode suivante",
    en: "Next Period",
    de: "Nächste Periode"
  },
  logged_in_users_follow_their: {
    nl: "Aangemelde gebruikers volgen hun",
    fr: "Les utilisateurs connectés suivent leurs",
    en: "Logged in users follow their",
    de: "Angemeldete Benutzer folgen ihren"
  },
  favorite_entrepreneurs: {
    nl: "favoriete ondernemers",
    fr: "entrepreneurs préférés",
    en: "favorite entrepreneurs",
    de: "Lieblingsunternehmern"
  },
  and_have_access_to: {
    nl: "en hebben toegang tot:",
    fr: "et ont accès à :",
    en: " and have access to:",
    de: " und haben Zugriff auf:"
  },
  promotions_that_will_be_offered_in_the_future: {
    nl: "Promoties die in de toekomst zullen aangeboden worden",
    fr: "Les promotions qui seront proposées à l'avenir",
    en: "Promotions that will be offered in the future",
    de: "Aktionen, die in Zukunft angeboten werden"
  },
  exceptional_offers_especially_for_loyal_customers: {
    nl: "Uitzonderlijke aanbiedingen speciaal voor trouwe klanten",
    fr: "Des offres exceptionnelles notamment pour les clients fidèles",
    en: "Exceptional offers especially for loyal customers",
    de: "Außergewöhnliche Angebote, insbesondere für treue Kunden"
  },
  the_ability_to_create_smart_shopping_lists: {
    nl: "De mogelijkheid om slimme boodschappenlijsten aan te leggen",
    fr: "La possibilité de créer des listes de courses intelligentes",
    en: "The ability to create smart shopping lists",
    de: "Die Möglichkeit, intelligente Einkaufslisten zu erstellen"
  },
  you_cant_follow_2_stores_of_the_same_category: {
    nl: "Je kan geen 2 winkels van dezelfde formule volgen.",
    fr: "Vous ne pouvez pas suivre 2 magasins de la même formule",
    en: "You can't follow 2 stores of the same category.",
    de: "Sie können nicht 2 Geschäfte der gleichen Kategorie folgen."
  },
  you_follow: {
    nl: "Jij volgt",
    fr: "Vous suivez",
    en: "You follow",
    de: "Sie folgen"
  }
};
var _default = General;
exports["default"] = _default;